import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { ArchiveLogo } from './ArchiveLogo';
import { ARCHIVE_CONTACT } from './archiveData';
const PRODUCT_LINKS = [{
  label: 'Class IV Laser',
  href: '#category-class-iv-laser'
}, {
  label: 'Shockwave',
  href: '#category-shockwave'
}, {
  label: 'High Energy Inductive Therapy',
  href: '#category-high-energy-inductive-therapy'
}, {
  label: 'Whole Body Red Light / LED Therapy',
  href: '#category-whole-body-red-light-led-therapy'
}, {
  label: 'Thermal Imaging',
  href: '#category-thermal-imaging'
}, {
  label: 'Peptides/Stem Cells',
  href: '#category-peptides-stem-cells'
}, {
  label: 'RegenOMedix',
  href: '#category-peptides-stem-cells',
  nested: true
}, {
  label: 'Used Equipment',
  href: '#category-used-equipment'
}, {
  label: 'Concierge Modality Suite',
  href: '#category-concierge-modality-suite'
}, {
  label: 'Neuro Reformer',
  href: '#category-neuro-reformer'
}];
const NAV = [{
  label: 'Concierge Suite',
  href: '#concierge'
}, {
  label: 'Used Equipment',
  href: '#used-equipment'
}, {
  label: 'About',
  to: '/about'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function ArchiveHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [desktopProductsOpen, setDesktopProductsOpen] = useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  function closeAllMenus() {
    setMobileMenuOpen(false);
    setDesktopProductsOpen(false);
    setMobileProductsOpen(false);
  }
  function handleSamePageAnchorClick(event: React.MouseEvent<HTMLAnchorElement>, hash: string) {
    event.preventDefault();
    const target = document.querySelector(hash);
    if (!target) return;
    closeAllMenus();
    window.setTimeout(() => {
      const header = document.querySelector('header');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const targetTop = target.getBoundingClientRect().top + window.scrollY;
      const top = Math.max(0, targetTop - headerHeight - 20);
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }, 50);
  }
  return <header className="sticky top-0 z-50 w-full border-b border-white/15 bg-navy text-white shadow-[0_8px_24px_-16px_rgba(9,10,42,0.8)]" data-id="element-93" data-mp="1qx0hnqc7fj49">
      <div className="mx-auto flex h-[82px] max-w-7xl items-center justify-between px-5 sm:px-8 xl:px-3" data-id="element-94" data-mp="1zz9redznf8gl">
        <Link to="/2026-07-28.html" aria-label="JAG Medical Solutions home" onClick={closeAllMenus} className="rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-95" data-mp="24y35o8mrf3ht">
          <ArchiveLogo data-id="element-96" data-mp="2jnskv7rot813" />
        </Link>

        <nav className="hidden items-center gap-3 xl:flex" aria-label="Primary" data-id="element-97" data-mp="2jotynk0388mi">
          <Link to="/2026-07-28.html" className="relative py-2 text-[15px] font-medium text-teal-light transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy" data-id="element-98" data-mp="2npvxhzq3einy">
            Home
            <span className="absolute bottom-0 left-0 h-0.5 w-full bg-teal" data-id="element-99" data-mp="31cgjek3bc8a" />
          </Link>

          <div className="group relative" onMouseEnter={() => setDesktopProductsOpen(true)} onMouseLeave={() => setDesktopProductsOpen(false)} onKeyDown={event => {
          if (event.key === 'Escape') setDesktopProductsOpen(false);
        }} data-id="element-100" data-mp="3u8f5dzcgh6fc">
            <button type="button" aria-controls="archive-products-menu" aria-expanded={desktopProductsOpen} aria-haspopup="menu" onClick={() => setDesktopProductsOpen(value => !value)} className={`inline-flex items-center gap-1.5 py-2 text-[15px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy ${desktopProductsOpen ? 'text-teal-light' : 'text-white/80 hover:text-teal-light'}`} data-id="element-101" data-mp="lxu5xpbgv01d">
              Products
              <ChevronDownIcon className={`h-4 w-4 transition-transform ${desktopProductsOpen ? 'rotate-180' : ''}`} data-id="element-102" data-mp="kbeqkk654k6c" />
            </button>

            <span className="pointer-events-auto absolute left-0 top-full z-[59] h-3 w-[360px] max-w-[calc(100vw-40px)]" aria-hidden="true" data-id="element-103" data-mp="1cy9570ga0pbw" />
            <div id="archive-products-menu" className={`invisible pointer-events-none absolute left-0 top-full z-[60] mt-3 w-[360px] max-w-[calc(100vw-40px)] origin-top rounded-lg border border-white/15 bg-navy p-2 opacity-0 shadow-2xl shadow-black/35 transition-[opacity,transform,visibility] duration-150 group-hover:visible group-hover:pointer-events-auto group-hover:opacity-100 group-focus-within:visible group-focus-within:pointer-events-auto group-focus-within:opacity-100 ${desktopProductsOpen ? 'visible pointer-events-auto opacity-100' : ''}`} role="menu" aria-label="Products" data-id="element-104" data-mp="1374tc9lwdkla">
              <div className="grid gap-0.5" data-id="element-105" data-mp="3q4pbtnk7mih4">
                {PRODUCT_LINKS.map(item => <a key={item.label} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className={`whitespace-nowrap rounded-md py-2 text-[15px] font-medium text-white/85 transition-colors hover:bg-white/10 hover:text-teal-light focus-visible:outline-none focus-visible:bg-white/10 focus-visible:text-teal-light ${item.nested ? 'ml-3 border-l border-teal/40 pl-3 pr-3 text-[14px] text-teal-light/90' : 'px-3'}`} role="menuitem" data-id="element-106" data-mp="32ev2hfz3nc1m">
                    {item.label}
                  </a>)}
              </div>
              <div className="my-2 border-t border-white/15" data-id="element-107" data-mp="3kgsco1hhh2gx" />
              <a href="#product-of-the-month" onClick={event => handleSamePageAnchorClick(event, '#product-of-the-month')} className="block rounded-md px-3 py-2 text-[15px] font-semibold text-teal-light transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:bg-white/10" role="menuitem" data-id="element-108" data-mp="3kjehvugwj5vz">
                Product of the Month
              </a>
            </div>
          </div>

          {NAV.map(item => {
          const className = 'relative py-2 text-[15px] font-medium text-white/80 transition-colors hover:text-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy';
          return item.href ? <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className={className} data-id="element-109" data-mp="2ai954q7wc1zb">
                {item.label}
              </a> : <Link key={item.to} to={item.to ?? '/'} className={className} data-id="element-110" data-mp="1wk2he2wnvidd">
                {item.label}
              </Link>;
        })}
        </nav>

        <div className="flex items-center gap-3" data-id="element-111" data-mp="1rm9b79vcyod3">
          <a href={ARCHIVE_CONTACT.phoneHref} className="hidden items-center gap-2 rounded-full bg-teal px-5 py-2.5 text-[15px] font-semibold text-white transition-colors hover:bg-teal-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-navy sm:inline-flex" data-id="element-112" data-mp="1msoi9w8mgkkr">
            <PhoneIcon className="h-4 w-4" data-id="element-113" data-mp="13ubyzhnzxubg" />
            Book a Call
          </a>
          <button type="button" className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-white transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-light focus-visible:ring-offset-2 focus-visible:ring-offset-navy xl:hidden" onClick={() => setMobileMenuOpen(value => !value)} aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileMenuOpen} data-id="element-114" data-mp="2rrjrd76lcghn">
            {mobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-115" data-mp="2dsk3i1qwk5mj" /> : <MenuIcon className="h-6 w-6" data-id="element-116" data-mp="1z35uiur8nq7o" />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && <div className="max-w-full overflow-hidden border-t border-white/15 bg-navy xl:hidden" data-id="element-117" data-mp="2430hin7w7vng">
          <nav className="mx-auto flex w-full max-w-7xl flex-col px-5 py-3 sm:px-8" aria-label="Mobile" data-id="element-118" data-mp="1q390sepzs15r">
            <Link to="/2026-07-28.html" onClick={closeAllMenus} className="border-b border-white/10 py-3 text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light" data-id="element-119" data-mp="1v3dkseq3ze0q">
              Home
            </Link>

            <div className="border-b border-white/10" data-id="element-120" data-mp="1khqiko67r2to">
              <button type="button" onClick={() => setMobileProductsOpen(value => !value)} aria-expanded={mobileProductsOpen} className="flex w-full items-center justify-between py-3 text-left text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light" data-id="element-121" data-mp="1ge2cyb156hb2">
                Products
                <ChevronDownIcon className={`h-4 w-4 transition-transform ${mobileProductsOpen ? 'rotate-180' : ''}`} data-id="element-122" data-mp="1z538ep31zupv" />
              </button>
              {mobileProductsOpen && <div className="mb-3 max-w-full rounded-lg border border-white/10 bg-white/[0.05] p-2" data-id="element-123" data-mp="2869t7acqjrox">
                  {PRODUCT_LINKS.map(item => <a key={item.label} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className={`block break-words rounded-md py-2.5 text-sm font-medium text-white/80 hover:bg-white/10 hover:text-teal-light ${item.nested ? 'ml-3 border-l border-teal/40 pl-3 pr-3 text-teal-light/90' : 'px-3'}`} data-id="element-124" data-mp="2soj1qq0if5d7">
                      {item.label}
                    </a>)}
                  <div className="my-1.5 border-t border-white/15" data-id="element-125" data-mp="31lte6ep2d0jp" />
                  <a href="#product-of-the-month" onClick={event => handleSamePageAnchorClick(event, '#product-of-the-month')} className="block rounded-md px-3 py-2.5 text-sm font-semibold text-teal-light hover:bg-white/10" data-id="element-126" data-mp="2wojg6anlzgk9">
                    Product of the Month
                  </a>
                </div>}
            </div>

            {NAV.map(item => item.href ? <a key={item.href} href={item.href} onClick={event => handleSamePageAnchorClick(event, item.href)} className="border-b border-white/10 py-3 text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light" data-id="element-127" data-mp="ao856hqdo10g">
                  {item.label}
                </a> : <Link key={item.to} to={item.to ?? '/'} onClick={closeAllMenus} className="border-b border-white/10 py-3 text-[15px] font-medium text-white/85 transition-colors hover:text-teal-light" data-id="element-128" data-mp="tdevoqxexwwt">
                  {item.label}
                </Link>)}
            <a href={ARCHIVE_CONTACT.phoneHref} onClick={closeAllMenus} className="mt-4 inline-flex items-center justify-center gap-2 rounded-full bg-teal px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-teal-light" data-id="element-129" data-mp="2s5rpigiq5gif">
              <PhoneIcon className="h-4 w-4" data-id="element-130" data-mp="2x3kwvcvrkgka" />
              Call {ARCHIVE_CONTACT.phone}
            </a>
          </nav>
        </div>}
    </header>;
}